import { useState } from "react";
import { Monitor, Smartphone, PanelsTopLeft } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const OPTS = [
  ["banner-mobile", "Mobil", "1122×1402", Smartphone],
  ["banner-desktop", "Desktop", "1870×841", Monitor],
  ["banner-both", "Ambele", "desktop + mobil", PanelsTopLeft],
];
export const BANNER_LABEL = { "banner-mobile": "Banner mobil", "banner-desktop": "Banner desktop", "banner-both": "Banner desktop + mobil" };

export const BannerPicker = ({ ar, setAr }) => {
  const [open, setOpen] = useState(false);
  const on = ar.startsWith("banner");
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid="format-banner" className={`rounded-full border px-2.5 py-0.5 text-xs ${on ? "border-amber-400 bg-amber-400 text-zinc-950" : "border-zinc-700 text-zinc-400"}`}>
          {on ? BANNER_LABEL[ar] : "Banner site"}</button>
      </PopoverTrigger>
      <PopoverContent className="w-64 space-y-1 p-2" data-testid="banner-picker">
        <p className="px-1 pb-1 text-xs text-zinc-500">Pentru ce ecran e bannerul?</p>
        {OPTS.map(([k, l, d, Icon]) => (
          <button key={k} data-testid={`banner-opt-${k}`} onClick={() => { setAr(k); setOpen(false); }}
            className={`flex w-full items-center gap-2 rounded-lg px-2 py-1.5 text-left text-sm hover:bg-zinc-100 ${ar === k ? "bg-amber-100" : ""}`}>
            <Icon className="h-4 w-4" /> <span className="font-medium">{l}</span> <span className="ml-auto text-[11px] text-zinc-500">{d}</span>
          </button>
        ))}
        <p className="px-1 pt-1 text-[11px] text-zinc-500">Scrie apoi în chat ce banner vrei (titlu, produse, campanie). Fișierul iese exact la dimensiunea bannerelor de pe site.</p>
      </PopoverContent>
    </Popover>
  );
};
